module.exports = __webpack_public_path__ + "static/media/DemoActive.af633d8f.svg";